<div class="file-tag-chip-section" [ngClass]="{ 'inline-mode': inlineMode }">
    <ng-container *ngIf="chipHeader.length">
        <h4 class="file-tag-section-title job-detail-title">{{ chipHeader | translate }}</h4>
    </ng-container>

    <loading *ngIf="loading"></loading>

    <ng-container *ngIf="!loading">
        <div class="chips-container" [ngClass]="{ 'inline-mode': inlineMode }" #chipsContainer>
            <mat-chip-listbox [ngClass]="{ 'inline-mode': inlineMode }">
                <!-- Only render visible tags when in inline mode -->
                <ng-container *ngFor="let file of inlineMode ? visibleTagsOrFiles : files">
                    <mat-chip
                        class="file-chip"
                        [ngClass]="'file-chip-' + chipType"
                        (click)="handleFileClick(file)"
                        [title]="file.label"
                        [disabled]="isDownloading(file.label)"
                        [disableRipple]="disableRipple"
                    >
                        <div class="icon-container">
                            <ng-container *ngIf="isDownloading(file.label); else normalIcon">
                                <div class="button-loader"></div>
                            </ng-container>

                            <ng-template #normalIcon>
                                <i class="icon-{{ chipIcon }} i16"></i>
                            </ng-template>
                        </div>

                        <span class="chip-label">{{ file.label }}</span>
                        <div class="chip-action" *ngIf="cancelAction">
                            <button matChipRemove class="remove-button" (click)="handleCancel(file)">&#x2716;</button>
                        </div>
                    </mat-chip>
                </ng-container>

                <!-- Overflow counter chip inside the chip-listbox -->
                <mat-chip
                    *ngIf="inlineMode && overflowCount > 0"
                    class="file-chip overflow-chip"
                    [title]="overflowTitle"
                    [disableRipple]="disableRipple"
                >
                    <span>+{{ overflowCount }}</span>
                </mat-chip>
            </mat-chip-listbox>
        </div>

        <div *ngIf="!files || files.length === 0" class="no-data-label">{{ noFilesMessage | translate }}</div>
    </ng-container>
</div>
